import type { StateCreator } from 'zustand'

import type { Theme } from '../../types/common'
import isSportsSection from '../../utils/isSportsSection'
import type { AllSlices } from '../types'
import type { CommonSlice } from '../types/common'

// Auto-hide timer for the coin animation: tracked so a second show within the
// 3s window restarts the countdown instead of being cut short by the first
// timer.
let coinAnimTimer: ReturnType<typeof setTimeout> | null = null

export const createCommonSlice: StateCreator<
  AllSlices,
  [],
  [],
  CommonSlice
> = set => ({
  isChatVisible: false,
  casinoTheme: localStorage.getItem('casinoTheme')
    ? (localStorage.getItem('casinoTheme') as Theme)
    : 'dark',
  sportsTheme: localStorage.getItem('sportsTheme')
    ? (localStorage.getItem('sportsTheme') as Theme)
    : 'light',
  themeSponsors: localStorage.getItem('sponsorsTheme')
    ? (localStorage.getItem('sponsorsTheme') as Theme)
    : 'light',
  theme: localStorage.getItem('casinoTheme')
    ? (localStorage.getItem('casinoTheme') as Theme)
    : 'dark',
  isTopAdVisible: true,
  isDownloadPwaVisible: false,
  isPendingDepositVisible: false,
  isCoinAnimVisible: false,
  isFullScreen: false,
  isDownloadVisible: true,
  isFloatingButtonsCollapsed: true,
  setIsCoinAnimVisible: isVisible => {
    set(state => ({
      common: { ...state.common, isCoinAnimVisible: isVisible },
    }))
    if (coinAnimTimer) {
      clearTimeout(coinAnimTimer)
      coinAnimTimer = null
    }
    if (isVisible) {
      coinAnimTimer = setTimeout(() => {
        coinAnimTimer = null
        set(state => ({
          common: { ...state.common, isCoinAnimVisible: false },
        }))
      }, 3000)
    }
  },
  setIsChatVisible: isVisible =>
    set(state => ({ common: { ...state.common, isChatVisible: isVisible } })),
  setCasinoTheme: (theme: Theme) =>
    set(state => ({
      common: {
        ...state.common,
        casinoTheme: theme,
        ...(!isSportsSection() &&
          !window.location.pathname.startsWith('/sponsors') && { theme }),
      },
    })),
  setSportsTheme: (theme: Theme) =>
    set(state => ({
      common: {
        ...state.common,
        sportsTheme: theme,
        ...(isSportsSection() && { theme }),
      },
    })),
  setThemeSponsors: (theme: Theme) =>
    set(state => ({
      common: {
        ...state.common,
        themeSponsors: theme,
        ...(window.location.pathname.startsWith('/sponsors') && { theme }),
      },
    })),
  setIsTopAdVisible: isVisible =>
    set(state => ({ common: { ...state.common, isTopAdVisible: isVisible } })),
  setIsDownloadPwaVisible: isVisible =>
    set(state => ({
      common: { ...state.common, isDownloadPwaVisible: isVisible },
    })),
  setIsPendingDepositVisible: isVisible =>
    set(state => ({
      common: { ...state.common, isPendingDepositVisible: isVisible },
    })),
  setIsFullScreen: isFullScreen =>
    set(state => ({
      common: { ...state.common, isFullScreen: isFullScreen },
    })),
  setIsDownloadVisible: isVisible =>
    set(state => ({
      common: { ...state.common, isDownloadVisible: isVisible },
    })),
  setIsFloatingButtonsCollapsed: isCollapsed =>
    set(state => ({
      common: { ...state.common, isFloatingButtonsCollapsed: isCollapsed },
    })),
})
